
// Test data for Level 3 Chipping Training

export const chippingTests = [
  {
    id: "chipping-plat",
    title: "Chipping balle levée sur terrain plat",
    description: "Positionner les balles pour les distances A=7, B=10, C=20 m (wedge de 60°, 56°, et 52°), jouer 10 balles et compter les points selon le cercle d'arrivée",
    icon: "⛳"
  },
  {
    id: "chipping-pente-droit",
    title: "Chipping balle levée Pente droite gauche",
    description: "Positionner les balles pour les distances A1=7, B1=10, C1=20 m (wedge de 60°, 56°, et 52°) prêt d'un green en pente, jouer 10 balles et compter les points selon le cercle d'arrivée",
    icon: "⛳"
  },
  {
    id: "chipping-pente-gauche",
    title: "Chipping balle levée Pente gauche droite",
    description: "Positionner les balles pour les distances A2=7, B2=10, C2=20 m (wedge de 60°, 56°, et 52°) prêt d'un green en pente, jouer 10 balles et compter les points selon le cercle d'arrivée",
    icon: "⛳"
  },
  {
    id: "chipping-roulee-plat",
    title: "Chipping balle roulée terrain plat",
    description: "Positionner les balles pour les distances A=3, B=7, C=10, D=20 m (fer 7 à 9), jouer 10 balles et compter les points selon le cercle d'arrivée",
    icon: "⛳"
  },
  {
    id: "chipping-roulee-pente",
    title: "Chipping balle roulée pente droite gauche",
    description: "Positionner les balles pour les distances A1=3, B1=7, C1=10, D1=20 m (fer 7 à 9), jouer 10 balles et compter les points selon le cercle d'arrivée",
    icon: "⛳"
  },
  {
    id: "chipping-roulee-pente-gauche",
    title: "Chipping balle roulée pente gauche droite",
    description: "Positionner les balles pour les distances A5=3, B5=7, C5=10, D5=20 m (fer 7 à 9), jouer 10 balles et compter les points selon le cercle d'arrivée",
    icon: "⛳"
  }
];
